import actions from "./actions";

const {
  FINANCE_DASHBOARD_BEGIN,
  FINANCE_DASHBOARD_SUCCESS,
  FINANCE_DASHBOARD_ERR,
  FINANCE_HISTORY_BEGIN,
  FINANCE_HISTORY_SUCCESS,
  FINANCE_HISTORY_ERR,
  FINANCE_HISTORY_RESET,
  FINANCE_DETAILS_BEGIN,
  FINANCE_DETAILS_SUCCESS,
  FINANCE_DETAILS_ERR,
  FINANCE_DETAILS_RESET,
  FINANCE_UPDATE_APPROVAL_STATUS_BEGIN,
  FINANCE_UPDATE_APPROVAL_STATUS_SUCCESS,
  FINANCE_UPDATE_APPROVAL_STATUS_ERR,
  FINANCE_UPDATE_APPROVAL_STATUS_RESET,
} = actions;

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const financeDashboardReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_DASHBOARD_BEGIN:
      return { ...initialState, loading: true };

    case FINANCE_DASHBOARD_SUCCESS:
      return { ...initialState, data, loading: false };

    case FINANCE_DASHBOARD_ERR:
      return { ...initialState, error: err, loading: false };

    default:
      return state;
  }
};

export const financeHistoryReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_HISTORY_BEGIN:
      return { ...initialState, loading: true };

    case FINANCE_HISTORY_SUCCESS:
      return { ...initialState, data, loading: false };

    case FINANCE_HISTORY_ERR:
      return { ...initialState, error: err, loading: false };

    case FINANCE_HISTORY_RESET:
      return initialState;

    default:
      return state;
  }
};

export const financeDetailsReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_DETAILS_BEGIN:
      return { ...initialState, loading: true };

    case FINANCE_DETAILS_SUCCESS:
      return { ...initialState, data, loading: false };

    case FINANCE_DETAILS_ERR:
      return { ...initialState, error: err, loading: false };

    case FINANCE_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};

export const financeUpdateApprovalStatusReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_UPDATE_APPROVAL_STATUS_BEGIN:
      return { ...initialState, loading: true };

    case FINANCE_UPDATE_APPROVAL_STATUS_SUCCESS:
      return { ...initialState, data, loading: false };

    case FINANCE_UPDATE_APPROVAL_STATUS_ERR:
      return { ...initialState, error: err, loading: false };

    case FINANCE_UPDATE_APPROVAL_STATUS_RESET:
      return initialState;

    default:
      return state;
  }
};
